export enum KnmListActionsEnum {
  KNM_LIST_INIT_PAGE = 'KNM_LIST_INIT_PAGE',
  KNM_LIST_SET_SEARCH_VALUE = 'KNM_LIST_SET_SEARCH_VALUE',
  KNM_LIST_GET_DATA = 'KNM_LIST_GET_DATA',
  KNM_LIST_GET_DATA_NEXT_PAGE = 'KNM_LIST_GET_DATA_NEXT_PAGE',
  KNM_LIST_SET_DATA = 'KNM_LIST_SET_DATA',
  KNM_LIST_SET_ORDER = 'KNM_LIST_SET_ORDER',
  KNM_LIST_DELETE_KNMS = 'KNM_LIST_DELETE_KNMS',
  KNM_LIST_RESTORE_KNMS = 'KNM_LIST_RESTORE_KNMS',
  KNM_LIST_CANCEL_KNMS = 'KNM_LIST_CANCEL_KNMS',
  KNM_LIST_DISAPPROVE_KNMS = 'KNM_LIST_DISAPPROVE_KNMS',
  KNM_LIST_UPDATE_KNMS_START_DATE = 'KNM_LIST_UPDATE_KNMS_START_DATE',
  KNM_LIST_UPDATE_KNMS_DURATION = 'KNM_LIST_UPDATE_KNMS_DURATION',
  KNM_LIST_REMOVE_KNMS_FROM_PLAN = 'KNM_LIST_REMOVE_KNMS_FROM_PLAN',
  KNM_LIST_EXPORT_LIST = 'KNM_LIST_EXPORT_LIST',
  KNM_LIST_EXPORT_SIMILARITIES_LIST = 'KNM_LIST_EXPORT_SIMILARITIES_LIST',
  KNM_LIST_EXPORT_REGISTRY_KNM = 'KNM_LIST_EXPORT_REGISTRY_KNM',
  KNM_LIST_FIND_KNM = 'KNM_LIST_FIND_KNM',
  KNM_LIST_SET_FIND_DATA = 'KNM_LIST_SET_FIND_DATA',
  KNM_LIST_REMOVE_FROM_PLAN_CLICK = 'KNM_LIST_REMOVE_FROM_PLAN_CLICK',
  KNM_LIST_FIND_KNM_FOR_DECISION_REASON = 'KNM_LIST_FIND_KNM_FOR_DECISION_REASON',
  KNM_LIST_GET_KNM_SELECT_OPTIONS = 'KNM_LIST_GET_KNM_SELECT_OPTIONS',
  HAS_KNM_UNRESOLVED_VIOLATIONS = 'HAS_KNM_UNRESOLVED_VIOLATIONS',
}
